export enum SectorAlertTypes {
    bpi_direction_change = 1,
    bpi_signal = 2,
    bpi_status_change = 3,
    rs_direction_change = 4,
    wk_30_signal = 5,
    wk_30_direction_change = 6
}
